import React from "react"

function Table(props){
    return (
        <table className="easy-tbl">
            <thead>
                <tr style={{backgroundColor: '#009879',color: '#ffffff'}}>
                    <th style={{borderTopLeftRadius: '15px',}}>Amount (₦)</th>
                    <th style={{borderTopRightRadius: '15px',}}>Wallet Top Up (₦)</th>
                </tr>
            </thead>
            <tbody>
                <tr style={{borderBottom: '1px dashed #f0f0f0', textAlign: 'center',}}>
                    <td>
                    <pre style={{color: '#161616', fontSize: '1.1em'}}>
                        {props.amount}
                    </pre>
                    </td>
                    <td style={{backgroundColor: "#fafffe"}}>
                        <pre style={{color: '#009879',  fontSize: '1.1em', fontWeight: 'bold'}}>
                            {props.topup}
                        </pre>
                    </td>
                </tr>
                <tr>
                    <td>
                        <pre style={{color: '#b60000'}}>
                            Fee Charges (₦)
                        </pre>
                    </td>
                    <td>
                        <pre style={{ color: '#b60000' }}>
                            {props.fee}
                        </pre>
                    </td>
                </tr>
            </tbody>
        </table>
              
    )
}

export default Table 